/**
 * service
 */
import taskmanAxios from '../helpers/axios'
/**
 * const
 */
import { API_WORKSPACES_URL } from "../constants/api.constant";

export default class WorkspaceService {

    static async getWorkspaces(params?: { skip?: number; limit?: number }) {
        return await taskmanAxios.get(API_WORKSPACES_URL, { params })
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async createWorkspace(data: {
        name: string;
        is_public?: boolean;
        initial_members: { user_id: string }[];
    }) {
        return await taskmanAxios.post(API_WORKSPACES_URL, data)
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async updateWorkspace(workspaceId: number, data: {
        name: string;
        is_public: boolean;
    }) {
        return await taskmanAxios.put(`${API_WORKSPACES_URL}${workspaceId}`, data)
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async deleteWorkspace(workspaceId: number) {
        return await taskmanAxios.delete(`${API_WORKSPACES_URL}${workspaceId}`)
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }
}
